import { jsxs as n, jsx as a } from "react/jsx-runtime";
import "react";
import { NavList as e } from "../NavList/NavList.js";
import '../../assets/FooterNavigation.css';const r = {
  "footer-navigation": "_footer-navigation_8qkwj_1"
};
function m({ sections: t = [] }) {
  return /* @__PURE__ */ n("nav", { className: r["footer-navigation"], "aria-labelledby": "footer-navigation", children: [
    /* @__PURE__ */ a("h4", { className: "sr-only", id: "footer-navigation", children: "Footer Navigation" }),
    t.map((o, i) => /* @__PURE__ */ a(
      e,
      {
        links: o.links,
        title: o.title,
        classname: o.classname
      },
      `footer-section-${i + 1}`
    ))
  ] });
}
export {
  m as FooterNavigation,
  m as default
};
